import { render } from "./QuestionEditModal.vue?vue&type=template&id=aec0473a"
import script from "./QuestionEditModal.vue?vue&type=script&lang=js"
export * from "./QuestionEditModal.vue?vue&type=script&lang=js"

import "./QuestionEditModal.vue?vue&type=style&index=0&id=aec0473a&lang=css"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__